import { render } from "./SegmentRemove.vue?vue&type=template&id=59692d44&scoped=true"
import script from "./SegmentRemove.vue?vue&type=script&lang=js"
export * from "./SegmentRemove.vue?vue&type=script&lang=js"

import "./SegmentRemove.vue?vue&type=style&index=0&id=59692d44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59692d44"]])

export default __exports__